import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

interface FeatureCardProps {
  icon?: React.ReactNode;
  title: string;
  description: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ icon, title, description }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        height: '100%',
        border: '1px solid rgba(0, 0, 0, 0.08)',
        borderRadius: 2,
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          transform: 'translateY(-2px)',
        },
      }}
    >
      {icon && (
        <Box
          sx={{
            mb: 2,
            color: 'primary.main',
            display: 'flex',
            alignItems: 'center',
            fontSize: '2.5rem',
          }}
        >
          {icon}
        </Box>
      )}
      <Typography
        variant="h6"
        component="h3"
        sx={{
          fontWeight: 600,
          mb: 1.5,
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          lineHeight: 1.6,
        }}
      >
        {description}
      </Typography>
    </Paper>
  );
};

export default FeatureCard;
